import {React,useState} from 'react'
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import './Ourproduct.css';
import chetak from '../Assets/chetak.png' // Adjust the path as necessary
import perfectplus from '../Assets/perfectplus.png'
import samrat from '../Assets/samrat.png'
import samratadvanced from '../Assets/samratadvance.png'
import logo from '../Assets/shyam.png' // Adjust the path as necessary	
import Carousel from "react-multi-carousel"; // library install using npm install react-multi-carousel
import "react-multi-carousel/lib/styles.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Productcard from '../Maincontent/Productcard' // Your designed card component
import Cardsand from './Cardsand';
import brickfirst from '../Assets/brick.png'
import brickthree from '../Assets/Brick2.png'
import sand1 from '../Assets/sand3.png'
import sand2 from '../Assets/Sand1.png'	
import sand3 from '../Assets/sand4.png'
import giti from '../Assets/Sand.png'


const productSlides = [
  [
    {
	 img: chetak,
      title: "Cement Supreme",
      category: "Cement",
      description: "High-quality cement for strong foundations",
      author: "ABC Brand",
      authorImg : logo,
    },
    {
		img: perfectplus,
      title: "Elegant Granite",
      category: "Granite",
      description: "Polished granite stone for floors and walls",
      author: "XYZ Stone",
      authorImg : logo,
    },
    {
		img: chetak,
      title: "Modern Tiles",
      category: "Tiles",
      description: "Stylish tiles for modern homes",
      author: "TileCo",
      authorImg : logo,
    },
	{
		img: perfectplus,
      title: "Modern Tiles",
      category: "Tiles",
      description: "Stylish tiles for modern homes",
      author: "TileCo",
      authorImg : logo,
    },
  ],
  // Add more slides if needed
];

// Sample data (replace this with your own product list)
const products = [
	{ id: 1, title: "MP BIRLA CHETAK", image: chetak, price: "₹ 360 / Bag" },
	{ id: 2, title: "MP BIRLA PERFECT PLUS", image: perfectplus, price: "₹ 380 / Bag" },
	{ id: 3, title: "MP BIRLA SAMRAT", image: samrat, price: "₹ 370 / Bag" },
	{ id: 4, title: "MP BIRLA SAMRAT ADVANCED", image: samratadvanced, price: "₹400 / Bag" },
	
  ];

const Sandproducts = [
	{ id: 1, title: "Bricks", image: brickfirst, price: "₹ 5.5 / Piece",Descripriton: "Hanumangarh First No Bricks" },	
	{ id: 2, title: "Bricks", image: brickthree, price: "₹ 3.5 / Piece", Descripriton: "Hanumangarh Three No Bricks" },
	{ id: 3, title: "Sand", image:  sand1 , price: "₹ 85 / 100Kg", Descripriton: "Bajri Jamna" },	
	{ id: 4, title: "Sand", image: sand2, price: "₹ 90 / 100kg",Descripriton: "Bajri Lunkarnsar" },
	{ id: 5, title: "Sand", image: sand3, price: "₹ 80 / 100Kg",Descripriton: "Bajri Lodsar" },	
	{ id: 6, title: "Concrit/Giti", image: giti, price: "₹ 75 / 100Kg",Descripriton: "creser for building" },
]
  
  const responsive = {
	superLargeDesktop: { breakpoint: { max: 4000, min: 1400 }, items: 4 },
	desktop: { breakpoint: { max: 1400, min: 1024 }, items: 3 },
	tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
	mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
  };
  
  const CustomLeftArrow = ({ onClick }) => (
	<Button className="carousel-arrow left btn-outline-warning bg-white " onClick={onClick}>
	  <FaChevronLeft />
	</Button>
  );
  
  const CustomRightArrow = ({ onClick }) => (
	<Button className="carousel-arrow right btn-outline-warning bg-white" onClick={onClick}>
	  <FaChevronRight />
	</Button>
  );

	export	const Ourproduct = () => {
		return (
			<>
		  <div className="shadow pt-2 bg-body-tertiary rounded">
			<h2 className="text-center mb-2 heading bg-white border-top border-bottom shadow-sm">Our Cement Products</h2>
			<Carousel
			  responsive={responsive}
			  infinite
			  autoPlay
			  autoPlaySpeed={1500}
			  arrows={true}
			  renderButtonGroupOutside
			  customLeftArrow={<CustomLeftArrow />}
			  customRightArrow={<CustomRightArrow />}
			  swipeable
			  draggable
			  showDots={true}
			>
			  {products.map((product) => (
				<div key={product.id} className="p-3">
					 <Productcard product={product} />
				</div>
			  ))}
			</Carousel>
		  </div>
		 <div className="shadow gap-1 pt-2 bg-body-tertiary rounded">
		 <h2 className="text-center mb-2 heading bg-white border-top border-bottom shadow-sm">Our Sand/Bajri & Bricks Products</h2>
		 <Carousel
		  responsive={responsive}
			  infinite
			  autoPlay
			  autoPlaySpeed={1500}
			  arrows={true}
			  renderButtonGroupOutside
			  customLeftArrow={<CustomLeftArrow />}
			  customRightArrow={<CustomRightArrow />}
			  swipeable
			  draggable
			  showDots={false} >
					{Sandproducts.map((sandproduct) => (
				<div key={sandproduct.id} className="p-3">
				  <Cardsand product={sandproduct} />
				</div>
			  ))}
		 </Carousel>
			</div>
		  </>
		);
	  };
	  

